import VueI18n from 'vue-i18n';

export class ErrorUtils {
  static async getErrorMessageForUpload(code: number) {
    const i18n = this.loadI18n();
    let message = '';
    switch (code) {
      case 101:
        message = i18n.t('failedUpload.failed').toString();
        break;
      case 102:
        message = i18n.t('failedUpload.notApostilleFile').toString();
        break;
      case 103:
        message = i18n.t('failedUpload.notSupportFileType').toString();
        break;
      case 104:
        message = i18n.t('failedUpload.fileSizeOver').toString();
        break;
      case 105:
        message = i18n.t('failedUpload.apostilleExist').toString();
        break;
      case 106:
        message = i18n.t('failedUpload.privateCannotUpload').toString();
        break;
      case 107:
        message = i18n.t('failedUpload.auditError').toString();
        break;
      default:
        message = i18n.t('failedUpload.failed').toString();
        break;
    }
    return message;
  }

  static getErrorMessageForDelete(code: number) {
    const i18n = this.loadI18n();
    let message = '';
    switch (code) {
      case 201:
        message = i18n.t('failedDelete.deleteKeyLucked').toString();
        break;
      case 202:
        message = i18n.t('failedDelete.deleteKeyUnMatched').toString();
        break;
      default:
        message = i18n.t('failedDelete.failed').toString();
    }
    return message;
  }

  static loadI18n() {
    const i18n = new VueI18n({
      locale: navigator.language,
      fallbackLocale: 'en',
      messages: {
        en: require('../locales/en.json'),
        ja: require('../locales/ja.json'),
        uk: require('../locales/uk.json'),
      },
    });
    return i18n;
  }
}
